import { render, staticRenderFns } from "./transferRecord.vue?vue&type=template&id=c7ee84c2&scoped=true&"
import script from "./transferRecord.vue?vue&type=script&lang=js&"
export * from "./transferRecord.vue?vue&type=script&lang=js&"
import style0 from "./transferRecord.vue?vue&type=style&index=0&id=c7ee84c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ee84c2",
  null
  
)

export default component.exports